import { render, staticRenderFns } from "./DoubleTrebleCrochetIcon.vue?vue&type=template&id=bb2161c2&scoped=true"
import script from "./DoubleTrebleCrochetIcon.vue?vue&type=script&lang=js"
export * from "./DoubleTrebleCrochetIcon.vue?vue&type=script&lang=js"
import style0 from "./DoubleTrebleCrochetIcon.vue?vue&type=style&index=0&id=bb2161c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2161c2",
  null
  
)

export default component.exports